import { Accordion, AccordionDetails, AccordionSummary, Box, Button, Chip, Divider, Drawer, Fab, Grid, IconButton, List, ListItem, ListItemIcon, ListItemText, Paper, Stack, Table, TableBody, TableCell, TableHead, TableRow, Tooltip, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
// import AnimateButton from 'ui-component/extended/AnimateButton'
import { IconFileText } from '@tabler/icons';
import { useTheme } from '@mui/material/styles';
import PerfectScrollbar from 'react-perfect-scrollbar';
// import NotificationList from 'layout/MainLayout/Header/NotificationSection/NotificationList';
import { toast } from 'react-toastify';
import axiosInstance from 'custom-axios';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import InfoIcon from '@mui/icons-material/Info';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import RefreshIcon from '@mui/icons-material/Refresh';
import SearchOffRoundedIcon from '@mui/icons-material/SearchOffRounded';
import { fileContentTypes } from 'store/constant';
import DownloadIcon from "@mui/icons-material/Download";

// import axiosInstance from 'custom-axios';

const statusIcons = {
    success: <CheckCircleIcon sx={{ color: "green" }} />,
    error: <ErrorIcon sx={{ color: "red" }} />,
    NA: <InfoIcon sx={{ color: "gray" }} />
};

const getFileExtension = (fileName) => {
    return fileName.split('.').pop().toLowerCase();
};


const ClientPortfolioDrawer = ({ called_from, userId, setActiveParentStep, setActiveChildStep }) => {

    let loginType = localStorage.getItem('login_type');
    let loginId = localStorage.getItem('login_id');
    let managerLoginId = localStorage.getItem('manager_id');
    let managerId = loginType == 'client' ? managerLoginId : loginId;

    const theme = useTheme();
    const [anchorEl, setAnchorEl] = useState(null);
    const [open, setOpen] = useState(false);
    const [clientPortfolioData, setClientPortfolioData] = useState([])
    const [missingInfoData, setClientMissingInfoData] = useState([])
    const [attachmentFiles, setAttachmentFiles] = useState([])


    const fetchUserPortfolio = async () => {

        try {
            // showLoader()

            const response = await axiosInstance.get(`api/user-quick-view-details/${userId}`);

            if (response.status === 200) {

                setClientMissingInfoData(response.missing_information_data)
                setAttachmentFiles(response.attachment_files || [])

                const chartDataArray = response.data.map((portfolio) => {
                    const chartTitle = portfolio.assets.map((asset) => asset.title);
                    const chartValue = portfolio.assets.map((asset) => Number(asset.value));

                    return {
                        chartData: portfolio,
                        chartTitle,
                        chartValue,
                        editableValues: portfolio.assets.reduce((acc, asset) => {
                            acc[asset.title] = asset.value;
                            return acc;
                        }, {}),
                    };
                });


                setClientPortfolioData(chartDataArray);
                // setLoadingChart(true);
            }

        } catch (error) {
            // console.error("Error submitting questions:", error);
            toast.error("Something went wrong. Please try again.");
        }/*  finally {
                    hideLoader()
                } */
    }

    const handleRefresh = () => {
        fetchUserPortfolio()
    }

    const handleToggle = (event) => {
        setAnchorEl(anchorEl ? null : event.currentTarget);
        setOpen(!open);
    };

    const handleStepLink = async (parentStep, childStep) => {
        let endPoint = `api/change-form-step`;

        const submitData = { user_id: userId ? userId : 0, parent_step: parentStep, child_step: childStep }

        try {
            const response = await axiosInstance.post(endPoint, submitData);

            if (response.status === 200) {
                setActiveParentStep(parentStep)
                setActiveChildStep(childStep)
                setOpen(false);
            }

        } catch (error) {
            // console.error(error)
            toast.error('An error occurred when navigating back.')
        }
    }

    const renderEmptyState = (message = 'No record found') => (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1.5,
                p: 2,
                mt: 1,
                border: '1px dashed #c8d3dd',
                borderRadius: '12px',
                background: 'linear-gradient(135deg, #f8fbfd 0%, #eef4f8 100%)'
            }}
        >
            <Box
                sx={{
                    width: 42,
                    height: 42,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderRadius: '50%',
                    backgroundColor: '#dfeaf1',
                    color: '#4f6b81',
                    flexShrink: 0
                }}
            >
                <SearchOffRoundedIcon fontSize="small" />
            </Box>
            <Box>
                <Typography
                    variant="subtitle2"
                    sx={{ color: '#1f3b53', fontWeight: 600, lineHeight: 1.2 }}
                >
                    No records available
                </Typography>
                <Typography variant="body2" sx={{ color: '#5f7386', mt: 0.25 }}>
                    {message}
                </Typography>
            </Box>
        </Box>
    );

    const downloadRegulatoryFile = async (_name, id) => {
        try {
            const response = await axiosInstance.get(`api/download-regulatory-file/${id}/${userId}`, {
                responseType: 'blob',
                validateStatus: (status) => {
                    return status >= 200 && status < 500;
                },
            });

            const contentType = response.headers['content-type'];

            if (contentType && contentType.includes('application/json')) {
                // Handle error response
                const reader = new FileReader();
                reader.onload = () => {
                    const errorResponse = JSON.parse(reader.result);
                    toast.error(errorResponse.error || 'An error occurred.');
                };
                reader.readAsText(response.data);
            } else {
                // Use response.data directly (it's already a blob)
                const url = window.URL.createObjectURL(response.data);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', _name);
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(url); // Clean up
            }
        } catch (error) {
            toast.error('An error occurred while downloading the file.');
        }
    };

    const downloadAccountFile = async (_name, id) => {
        try {
            const response = await axiosInstance.get(
                `api/download-account-statement-file/${id}/${userId}`,
                {
                    responseType: 'blob',
                    validateStatus: (status) => {
                        return status >= 200 && status < 500;
                    },
                }
            );

            const contentType = response.headers['content-type'];

            if (contentType && contentType.includes('application/json')) {
                const reader = new FileReader();
                reader.onload = () => {
                    const errorResponse = JSON.parse(reader.result);
                    toast.error(errorResponse.error || 'File not found.');
                };
                reader.readAsText(response.data);
            } else {
                // Use response.data directly (it's already the blob)
                const url = window.URL.createObjectURL(response.data);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', _name);
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(url); // Clean up memory
            }
        } catch (error) {
            toast.error('An error occurred while downloading the file.');
        }
    };
    useEffect(() => {
        fetchUserPortfolio()
    }, [])
    return (
        <>
            <Tooltip title="Quick View">
                <Fab
                    component="div"
                    onClick={handleToggle}
                    size="medium"
                    variant="circular"
                    color="secondary"
                    sx={{
                        backgroundColor: '#FFB6C1',
                        borderRadius: 0,
                        borderTopLeftRadius: '50%',
                        borderBottomLeftRadius: '50%',
                        borderTopRightRadius: '50%',
                        borderBottomRightRadius: '4px',
                        top: '35%',
                        position: 'fixed',
                        right: 10,
                        zIndex: theme.zIndex.speedDial
                    }}
                >
                    {/* <AnimateButton type="rotate"> */}
                    <IconButton color="inherit" size="large" disableRipple>
                        <IconFileText />
                    </IconButton>
                    {/* </AnimateButton> */}
                </Fab>
            </Tooltip>

            <Drawer
                anchor="right"
                onClose={handleToggle}
                open={open}
                PaperProps={{
                    sx: {
                        width: '40%',
                        padding: '20px',
                        // paddingTop: called_from == 'client' ? '70px' : ''
                    }
                }}
            >
                <PerfectScrollbar component="div"> {/*  set width for inner content  */}
                    <Paper sx={{ marginLeft: 0 }}>
                        <Grid container spacing={1}>
                            <Grid item xs={12}>
                                <Grid container alignItems="center" justifyContent="space-between" sx={{ marginLeft: '5px', marginTop: '3px' }}>
                                    <Grid item>
                                        <Stack direction="row" spacing={2}>

                                            {/* <Typography variant="subtitle1"><strong>Client Activity</strong></Typography> */}

                                            {/* {notificationData.length > 0 &&
                                                <Chip
                                                    size="small"
                                                    label={notificationData.length}
                                                    sx={{
                                                        color: theme.palette.background.default,
                                                        bgcolor: theme.palette.warning.dark
                                                    }}
                                                />
                                            } */}
                                        </Stack>
                                    </Grid>
                                    {/* <Grid item>
                                        <Typography component={Link} to="#" variant="subtitle2" color="primary">
                                            Mark as all read
                                        </Typography>
                                    </Grid> */}
                                </Grid>
                            </Grid>

                            <Grid item xs={12} className='padding-top0px'>
                                <PerfectScrollbar className='ps-full-height' >
                                    {/* <NotificationList userId={userId} clientPortfolioData={clientPortfolioData} /> */}
                                    <Grid className='mt-2'>
                                        <Grid
                                            container
                                            direction="row"
                                            sx={{
                                                justifyContent: "space-between",
                                                alignItems: "center",
                                            }}
                                            className="padding10px"
                                        >
                                            <Grid>
                                                <Typography variant="subtitle2" color="primary" sx={{ fontSize: '13px' }}>
                                                    {clientPortfolioData[0]?.chartData?.user_name}
                                                </Typography>
                                            </Grid>
                                            <Grid>
                                                <Button
                                                    size="small"
                                                    variant="outlined"
                                                    endIcon={<RefreshIcon />}
                                                    onClick={handleRefresh}
                                                >
                                                    Refresh
                                                </Button>
                                            </Grid>
                                        </Grid>


                                        {/* <Grid container spacing={1} alignItems="center" >

                                        </Grid> */}
                                        {/* <Divider /> */}
                                        {clientPortfolioData?.map((portfolioData, portfolioIndex) => {
                                            return (
                                                <div className='portfolio-section' key={portfolioIndex}>
                                                    <Accordion>
                                                        <AccordionSummary expandIcon={<ArrowDropDownIcon />} aria-controls="panel1-content" id="panel1-header">
                                                            <Box sx={{ width: '100%' }}>
                                                                <Table size="small">
                                                                    <TableHead>
                                                                        <TableRow sx={{ borderBottom: '1.5px solid', borderColor: 'divider' }}>
                                                                            {['Account Type', 'Recommended Portfolio', 'Advisor Portfolio', 'All Portfolio', 'Enhanced Portfolio'].map((col) => (
                                                                                <TableCell key={col} sx={{ fontWeight: 500, fontSize: '12px', color: 'text.secondary', textTransform: 'uppercase', letterSpacing: '0.05em', py: 1.25 }}>
                                                                                    {col}
                                                                                </TableCell>
                                                                            ))}
                                                                        </TableRow>
                                                                    </TableHead>
                                                                    <TableBody>
                                                                        <TableRow hover>
                                                                            <TableCell sx={{ fontWeight: 500 }}>
                                                                                {portfolioData.chartData?.account_type_label}
                                                                            </TableCell>
                                                                            <TableCell>
                                                                                <Chip label={portfolioData.chartData?.account_recommended_portfolio_name || 'N/A'} size="small" color="info" variant="outlined" />
                                                                            </TableCell>
                                                                            <TableCell>
                                                                                <Chip label={portfolioData.chartData?.advisor_recommended_risk_category_name || 'N/A'} size="small" color="success" variant="outlined" />
                                                                            </TableCell>
                                                                            <TableCell>
                                                                                <Chip label={portfolioData.chartData?.all_portfolio_name || 'N/A'} size="small" color="secondary" variant="outlined" />
                                                                            </TableCell>
                                                                            <TableCell>
                                                                                <Chip label={portfolioData.chartData?.enhanced_portfolio_name || 'N/A'} size="small" color="primary" variant="outlined" />
                                                                            </TableCell>
                                                                        </TableRow>
                                                                    </TableBody>
                                                                </Table>
                                                            </Box>
                                                        </AccordionSummary>


                                                        <AccordionDetails>
                                                            {(() => {
                                                                const categories = Array.isArray(portfolioData.chartData?.category)
                                                                    ? portfolioData.chartData.category
                                                                    : [];
                                                                const assets = Array.isArray(portfolioData.chartData?.assets)
                                                                    ? portfolioData.chartData.assets
                                                                    : [];

                                                                if (!categories.length) {
                                                                    return renderEmptyState('There are no categories or assets to display for this portfolio.');
                                                                }

                                                                return categories.map((row, categoryIndex) => {
                                                                    const categoryAssets = assets.filter(
                                                                        (asset) => asset.category === row.id && row.id !== 99
                                                                    );

                                                                    return (
                                                                        <div className='chart-asset-category' key={categoryIndex}>
                                                                            <h6>{row.category}</h6>
                                                                            {categoryAssets.length ? (
                                                                                <ul>
                                                                                    {categoryAssets.map((asset, assetIndex) => {
                                                                                        return (
                                                                                            <li key={assetIndex} className='padding5px'>
                                                                                                <span>
                                                                                                    {asset.title} : {portfolioData.editableValues[asset.title] || '0.00'}%
                                                                                                </span>
                                                                                            </li>
                                                                                        );
                                                                                    })}
                                                                                </ul>
                                                                            ) : (
                                                                                renderEmptyState('No assets were found under this category.')
                                                                            )}
                                                                        </div>
                                                                    );
                                                                });
                                                            })()}
                                                        </AccordionDetails>
                                                    </Accordion>
                                                    <Divider />
                                                    {/* {(portfolioIndex > 0) && <Divider />} */}
                                                </div>
                                            );
                                        })}
                                    </Grid>


                                    {/* ------- download docs----------- */}
                                    <Grid item xs={12} sx={{ mt: 2 }}>
                                        <Typography component="h2" variant="h5" gutterBottom sx={{
                                            fontWeight: "bold",
                                            color: "#3f51b5"
                                        }}>
                                            Identification Documents
                                        </Typography>
                                        <Divider />
                                    </Grid>

                                    <Box sx={{ mt: 2 }}>
                                        {[
                                            { file_id: 1, key: "id_proof_file", label: "ID Proof" },
                                            { file_id: 2, key: "driver_license_file", label: "Driver License" },
                                            { file_id: 3, key: "passport_file", label: "Passport" },
                                            { file_id: 4, key: "other_file", label: "Other" },
                                            { file_id: 5, key: "void_cheque_file", label: "Void Cheque" },
                                        ].map(({ file_id, key, label }, index) => (
                                            <Box
                                                key={key}
                                                sx={{
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    alignItems: 'center',
                                                    p: 1.5,
                                                    mb: 1,
                                                    bgcolor: index % 2 === 0 ? '#f5f5f5' : '#fff',
                                                    borderRadius: 1,
                                                    border: '1px solid #e0e0e0'
                                                }}
                                            >
                                                <Box>
                                                    <Typography variant="body2" sx={{ fontWeight: 500, mb: 0.5 }}>
                                                        {label}
                                                    </Typography>
                                                    {attachmentFiles?.regulatory_files?.[key] ? (
                                                        <Typography
                                                            variant="caption"
                                                            title={attachmentFiles.regulatory_files[key]}
                                                            sx={{
                                                                color: 'text.secondary',
                                                                display: 'block',
                                                                maxWidth: 400,
                                                                whiteSpace: 'nowrap',
                                                                overflow: 'hidden',
                                                                textOverflow: 'ellipsis'
                                                            }}
                                                        >
                                                            {attachmentFiles.regulatory_files[key]}
                                                        </Typography>
                                                    ) : (
                                                        <Typography variant="caption" sx={{ color: '#999', fontStyle: 'italic' }}>
                                                            File Not Found
                                                        </Typography>
                                                    )}
                                                </Box>
                                                {attachmentFiles?.regulatory_files?.[key] && (
                                                    <IconButton
                                                        size="small"
                                                        onClick={() => downloadRegulatoryFile(attachmentFiles.regulatory_files[key], file_id)}
                                                    >
                                                        <DownloadIcon fontSize="small" />
                                                    </IconButton>
                                                )}
                                            </Box>
                                        ))}
                                    </Box>

                                    <Grid item xs={12}>
                                        <Typography component="h2" variant="h5" gutterBottom sx={{
                                            fontWeight: "bold",
                                            color: "#3f51b5",
                                            mt: 3
                                        }}>
                                            Uploaded Statement
                                        </Typography>
                                        <Divider />
                                    </Grid>

                                    <Box sx={{ mt: 2 }}>
                                        {attachmentFiles?.account_files?.length > 0 ? (
                                            attachmentFiles.account_files.map((file, index) => (
                                                <Box
                                                    key={file.id}
                                                    sx={{
                                                        display: 'flex',
                                                        justifyContent: 'space-between',
                                                        alignItems: 'center',
                                                        p: 1.5,
                                                        mb: 1,
                                                        bgcolor: index % 2 === 0 ? '#f5f5f5' : '#fff',
                                                        borderRadius: 1,
                                                        border: '1px solid #e0e0e0'
                                                    }}
                                                >
                                                    <Box>
                                                        <Typography
                                                            variant="body2"
                                                            title={file.file_name}
                                                            sx={{
                                                                fontWeight: 500,
                                                                mb: 0.5,
                                                                maxWidth: 400,
                                                                whiteSpace: 'nowrap',
                                                                overflow: 'hidden',
                                                                textOverflow: 'ellipsis'
                                                            }}
                                                        >
                                                            {file.file_name}
                                                        </Typography>
                                                        <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                                                            {file.created_at}
                                                        </Typography>
                                                    </Box>
                                                    <IconButton
                                                        size="small"
                                                        onClick={() => downloadAccountFile(file.file_name, file.id)}
                                                    >
                                                        <DownloadIcon fontSize="small" />
                                                    </IconButton>
                                                </Box>
                                            ))
                                        ) : (
                                            <Typography variant="body2" sx={{ color: 'text.secondary', p: 1.5 }}>
                                                No files available
                                            </Typography>
                                        )}
                                    </Box>

                                    {Object.keys(missingInfoData).map((section) => (
                                        <Box key={section} sx={{ padding: 2 }}>
                                            <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                                                {section?.charAt(0)?.toUpperCase() + section?.slice(1)}
                                            </Typography>
                                            <List>
                                                {missingInfoData[section].map((item, index) => (
                                                    <ListItem key={index} divider>
                                                        <ListItemIcon>
                                                            {statusIcons[item.status] || <InfoIcon />}
                                                        </ListItemIcon>
                                                        {/* <ListItemText */}
                                                        <Box sx={{
                                                            flex: 1, // Take remaining space
                                                            overflow: 'hidden'
                                                        }}>
                                                            <ListItemText
                                                                primary={item.title}
                                                                secondary={
                                                                    <>
                                                                        <div>
                                                                            {item.status === "NA"
                                                                                ? "This section is not applicable."
                                                                                : item.message}
                                                                        </div>

                                                                        {item.highlight && item.highlight_message && (
                                                                            <div style={{ color: '#FFCC00', fontStyle: 'italic' }}>
                                                                                {item.highlight_message}
                                                                            </div>
                                                                        )}
                                                                    </>
                                                                }
                                                                secondaryTypographyProps={{ component: 'div' }}
                                                                sx={{
                                                                    whiteSpace: 'normal', // Allow the text to wrap
                                                                    wordWrap: 'break-word', // Ensures long words break and wrap
                                                                    overflow: 'visible', // Allow overflow if the message exceeds container width
                                                                    width: 'auto', // Use full available width
                                                                }}
                                                            />
                                                        </Box>
                                                        {/* {item.highlight && item.highlight_message && (
                                                            <Box
                                                                component="br"
                                                                sx={{
                                                                    display: 'block',
                                                                    mt: 0.5,
                                                                    color: '#FFCC00',
                                                                    fontStyle: 'italic',
                                                                    fontWeight: 500,
                                                                }}
                                                            >
                                                                {item.highlight_message}
                                                            </Box>
                                                        )} */}

                                                        {item.status === 'error' && (
                                                            <Button
                                                                size="small"
                                                                variant="outlined"
                                                                endIcon={<ArrowForwardIosIcon />}
                                                                onClick={() => handleStepLink(item.parent_step, item.child_step)}
                                                            >
                                                                Go to form
                                                            </Button>
                                                        )}
                                                    </ListItem>
                                                ))}
                                            </List>
                                        </Box>
                                    ))}
                                </PerfectScrollbar>
                            </Grid>

                            {/* <Divider />
                            <Grid container justifyContent="center">
                                <CardActions sx={{ p: 1.25 }}>
                                    <Button size="small" disableElevation>
                                        View All
                                    </Button>
                                </CardActions>
                            </Grid> */}
                        </Grid>
                    </Paper>
                </PerfectScrollbar>
            </Drawer>
        </>
    )
}

export default ClientPortfolioDrawer
